<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="robot" /> {{$t('translateCall')}}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-tabs v-model="filterFormModel.status" @input="load">
          <b-tab :title="$t('all')"></b-tab>
          <b-tab :title="$t('submit')"></b-tab>
          <b-tab :title="$t('confirmed')"></b-tab>
          <b-tab :title="$t('canceled')"></b-tab>
          <b-tab :title="$t('finish')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <admin-user-select class="mr-1 mb-1" :model="filterFormModel" attribute="user"
                               :place-holder="$t('translator')"></admin-user-select>
            <admin-user-select v-if="filterFormModel.status !== 1" class="mr-1 mb-1" :model="filterFormModel" attribute="approveBy"
                               :place-holder="$t('approveBy')"></admin-user-select>
            <form-select :model="filterFormModel" attribute="time" :options="[
              {value: 'createTime', text: $t('filterByCreateTime')},
              {value: 'submitTime', text: $t('filterBySubmitTime')},
              {value: 'confirmTime', text: $t('filterByConfirmTime')},
              {value: 'cancelTime', text: $t('filterByCancelTime')},
              {value: 'finishTime', text: $t('filterByFinishTime')}
            ]" class="mr-1 mb-1" @change="load"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t(filterFormModel.time)" class="mr-1 mb-1" :defaultShortcut="8" />

            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>

        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-3">{{ $t('callInfo') }}</div>
            <div class="col-lg-4">{{ $t('left') }}</div>
            <div class="col-lg-4">{{ $t('right') }}</div>
            <div class="col-lg-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-3">
              <p>
                <font-awesome-icon :class="iconClass(item.call)" size="2x" :icon="icon(item.call)" />
                {{ $t(item.call.direction) }} | <span>{{ item.call.hangupCause }}</span>
              </p>
              <p>
                <b>ID:&nbsp;</b><span>{{ item.call._id.toString() }}</span>
              </p>
              <p>
                <b>{{ $t('duration') }}:&nbsp;</b><span>{{ item.call.duration | callDuration }}</span>
              </p>
              <p>
                <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ item.call.billDuration | callDuration }}</span>
              </p>
              <app-audio v-if="item.call.recordingDownloaded" :id="item.call._id" :duration="item.call.duration" :bill-duration="item.call.billDuration" :show-skip="true" />
            </div>
            <div class="col-lg-4" style="justify-content: start;">
              <fieldset class="scheduler-border mb-0" :class="[item.leftOne && item.leftOne.confirmTime ? 'alert alert-success' : item.leftOne && item.leftOne.user ? 'alert alert-info' : 'alert alert-secondary']" style="min-height: 300px">
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("one")}}</b>
                </legend>
                <template v-if="item.leftOne && item.leftOne.user">
                  <div v-if="item.leftOne.user">
                    <b>{{$t('user')}}: </b> {{item.leftOne.user.name}}
                  </div>
                  <div v-if="item.leftOne.submitTime">
                    <b>{{$t('submitTime')}}: </b> {{item.leftOne.submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <template v-if="item.leftOne.confirmTime" >
                    <div>
                      <b>{{$t('confirmTime')}}: </b> {{item.leftOne.confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.leftOne.approveBy" >
                      <b>{{$t('confirmBy')}}: </b> {{item.leftOne.approveBy.name}}
                    </div>
                  </template>
                  <template v-if="item.leftOne.cancelTime" >
                    <div>
                      <b>{{$t('cancelTime')}}: </b> {{item.leftOne.cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.leftOne.approveBy" >
                      <b>{{$t('cancelBy')}}: </b> {{item.leftOne.approveBy.name}}
                    </div>
                  </template>
                  <div>
                    <span v-if="item.leftOne.change" class="mr-1 badge badge-warning mr-1">{{$t("adminChange")}}</span>
                    <span v-if="item.leftOne.cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                    <span v-else-if="item.leftOne.confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                    <span v-else-if="item.leftOne.submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                    <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>
                    <span v-if="item.leftOne.note" class="text-gray-999 small" >{{item.leftOne.note}}</span>
                  </div>
                  <div v-if="item.leftOne.transcripts && item.leftOne.transcripts.length">
                    <div :class="[(item.leftOne.transcripts.join(', ').length <= 120 && item.leftOne.transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                      <div class="c-voice-text__content" v-html="getTranscripts(item.leftOne.transcripts)" ></div>
                      <div v-if="item.leftOne.transcripts.join(', ').length > 120 || item.leftOne.transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                        <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                        <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-2" v-if="!item.finishTime && !item.leftOne.confirmTime && !item.leftOne.cancelTime">
                    <button type="button" class="btn btn-sm btn-primary mr-1" @click="update('leftOne', item)">
                      <i class="fa fa-edit mr-0"></i>
                      {{$t("edit")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-danger mr-1" @click="reject('leftOne', item)">
                      <i class="fa fa-remove mr-0"></i>
                      {{$t("reject")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-success" @click="approve('leftOne', item)">
                      <i class="fa fa-check-circle mr-0"></i>
                      {{$t("approve")}}
                    </button>
                  </div>
                </template>
                <div v-else class="text-center small text-gray-999">{{$t('noAction')}}</div>
              </fieldset>
              <fieldset class="scheduler-border mb-0" :class="[item.leftTwo && item.leftTwo.confirmTime ? 'alert alert-success' : item.leftTwo && item.leftTwo.user ? 'alert alert-primary' : 'alert alert-secondary']"  style="min-height: 300px">
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("two")}}</b>
                </legend>
                <template v-if="item.leftTwo && item.leftTwo.user">
                  <div v-if="item.leftTwo.user">
                    <b>{{$t('user')}}: </b> {{item.leftTwo.user.name}}
                  </div>
                  <div v-if="item.leftTwo.submitTime">
                    <b>{{$t('submitTime')}}: </b> {{item.leftTwo.submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <template v-if="item.leftTwo.confirmTime" >
                    <div>
                      <b>{{$t('confirmTime')}}: </b> {{item.leftTwo.confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.leftTwo.approveBy" >
                      <b>{{$t('confirmBy')}}: </b> {{item.leftTwo.approveBy.name}}
                    </div>
                  </template>
                  <template v-if="item.leftTwo.cancelTime" >
                    <div>
                      <b>{{$t('cancelTime')}}: </b> {{item.leftTwo.cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.leftTwo.approveBy" >
                      <b>{{$t('cancelBy')}}: </b> {{item.leftTwo.approveBy.name}}
                    </div>
                  </template>
                  <div>
                    <span v-if="item.leftTwo.change" class="mr-1 badge badge-warning mr-1">{{$t("adminChange")}}</span>
                    <span v-if="item.leftTwo.cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                    <span v-else-if="item.leftTwo.confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                    <span v-else-if="item.leftTwo.submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                    <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>

                    <span v-if="item.leftTwo.note" class="text-gray-999 small" >{{item.leftTwo.note}}</span>
                  </div>
                  <div v-if="item.leftTwo.transcripts && item.leftTwo.transcripts.length">
                    <div :class="[(item.leftTwo.transcripts.join(', ').length <= 120 && item.leftTwo.transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                      <div class="c-voice-text__content" v-html="getTranscripts(item.leftTwo.transcripts)" ></div>
                      <div v-if="item.leftTwo.transcripts.join(', ').length > 120 || item.leftTwo.transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                        <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                        <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-2" v-if="!item.finishTime && !item.leftTwo.confirmTime && !item.leftTwo.cancelTime">
                    <button type="button" class="btn btn-sm btn-primary mr-1" @click="update('leftTwo', item)">
                      <i class="fa fa-edit mr-0"></i>
                      {{$t("edit")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-danger mr-1" @click="reject('leftTwo', item)">
                      <i class="fa fa-remove mr-0"></i>
                      {{$t("reject")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-success" @click="approve('leftTwo', item)">
                      <i class="fa fa-check-circle mr-0"></i>
                      {{$t("approve")}}
                    </button>
                  </div>
                </template>
                <div v-else class="text-center small text-gray-999">{{$t('noAction')}}</div>
              </fieldset>
              <fieldset v-if="item.leftDiffWords" class="scheduler-border alert alert-info mb-0" >
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("diffWords")}} {{Math.ceil(item.leftDiffWords.similarity)}}%</b>
                </legend>
                <div>
                  <div :class="[(item.leftDiffWords.text.length <= 120) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                    <div class="c-voice-text__content" v-html="item.leftDiffWords.text" ></div>
                    <div v-if="item.leftDiffWords.text.length > 120" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                      <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                      <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-lg-4" style="justify-content: start;">
              <fieldset class="scheduler-border mb-0" :class="[item.rightOne && item.rightOne.confirmTime ? 'alert alert-success' : item.rightOne && item.rightOne.user ? 'alert alert-info' : 'alert alert-secondary']" style="min-height: 300px">
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("one")}}</b>
                </legend>
                <template v-if="item.rightOne && item.rightOne.user">
                  <div v-if="item.rightOne.user">
                    <b>{{$t('user')}}: </b> {{item.rightOne.user.name}}
                  </div>
                  <div v-if="item.rightOne.submitTime">
                    <b>{{$t('submitTime')}}: </b> {{item.rightOne.submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <template v-if="item.rightOne.confirmTime" >
                    <div>
                      <b>{{$t('confirmTime')}}: </b> {{item.rightOne.confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.rightOne.approveBy" >
                      <b>{{$t('confirmBy')}}: </b> {{item.rightOne.approveBy.name}}
                    </div>
                  </template>
                  <template v-if="item.rightOne.cancelTime" >
                    <div>
                      <b>{{$t('cancelTime')}}: </b> {{item.rightOne.cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.rightOne.approveBy" >
                      <b>{{$t('cancelBy')}}: </b> {{item.rightOne.approveBy.name}}
                    </div>
                  </template>
                  <div>
                    <span v-if="item.rightOne.change" class="mr-1 badge badge-warning mr-1">{{$t("adminChange")}}</span>
                    <span v-if="item.rightOne.cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                    <span v-else-if="item.rightOne.confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                    <span v-else-if="item.rightOne.submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                    <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>
                    <span v-if="item.rightOne.note" class="text-gray-999 small" >{{item.rightOne.note}}</span>
                  </div>
                  <div v-if="item.rightOne.transcripts && item.rightOne.transcripts.length">
                    <div :class="[(item.rightOne.transcripts.join(', ').length <= 120 && item.rightOne.transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                      <div class="c-voice-text__content" v-html="getTranscripts(item.rightOne.transcripts)" ></div>
                      <div v-if="item.rightOne.transcripts.join(', ').length > 120 || item.rightOne.transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                        <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                        <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-2" v-if="!item.finishTime && !item.rightOne.confirmTime && !item.rightOne.cancelTime">
                    <button type="button" class="btn btn-sm btn-primary mr-1" @click="update('rightOne', item)">
                      <i class="fa fa-edit mr-0"></i>
                      {{$t("edit")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-danger mr-1" @click="reject('rightOne', item)">
                      <i class="fa fa-remove mr-0"></i>
                      {{$t("reject")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-success" @click="approve('rightOne', item)">
                      <i class="fa fa-check-circle mr-0"></i>
                      {{$t("approve")}}
                    </button>
                  </div>
                </template>
                <div v-else class="text-center small text-gray-999">{{$t('noAction')}}</div>
              </fieldset>
              <fieldset class="scheduler-border mb-0" :class="[item.rightTwo && item.rightTwo.confirmTime ? 'alert alert-success' : item.rightTwo && item.rightTwo.user ? 'alert alert-primary' : 'alert alert-secondary']"  style="min-height: 300px">
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("two")}}</b>
                </legend>
                <template v-if="item.rightTwo && item.rightTwo.user">
                  <div v-if="item.rightTwo.user">
                    <b>{{$t('user')}}: </b> {{item.rightTwo.user.name}}
                  </div>
                  <div v-if="item.rightTwo.submitTime">
                    <b>{{$t('submitTime')}}: </b> {{item.rightTwo.submitTime | moment('DD/MM/YYYY HH:mm:ss')}}
                  </div>
                  <template v-if="item.rightTwo.confirmTime" >
                    <div>
                      <b>{{$t('confirmTime')}}: </b> {{item.rightTwo.confirmTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.rightTwo.approveBy" >
                      <b>{{$t('confirmBy')}}: </b> {{item.rightTwo.approveBy.name}}
                    </div>
                  </template>
                  <template v-if="item.rightTwo.cancelTime" >
                    <div>
                      <b>{{$t('cancelTime')}}: </b> {{item.rightTwo.cancelTime | moment('DD/MM/YYYY HH:mm:ss')}}
                    </div>
                    <div v-if="item.rightTwo.approveBy" >
                      <b>{{$t('cancelBy')}}: </b> {{item.rightTwo.approveBy.name}}
                    </div>
                  </template>
                  <div>
                    <span v-if="item.rightTwo.change" class="mr-1 badge badge-warning mr-1">{{$t("adminChange")}}</span>
                    <span v-if="item.rightTwo.cancelTime" class="mr-1 badge badge-danger">{{$t("canceled")}}</span>
                    <span v-else-if="item.rightTwo.confirmTime" class="mr-1 badge badge-success">{{$t("confirmed")}}</span>
                    <span v-else-if="item.rightTwo.submitTime" class="mr-1 badge badge-primary">{{$t("submit")}}</span>
                    <span v-else class="mr-1 badge badge-warning">{{$t("doing")}}</span>

                    <span v-if="item.rightTwo.note" class="text-gray-999 small" >{{item.rightTwo.note}}</span>
                  </div>
                  <div v-if="item.rightTwo.transcripts && item.rightTwo.transcripts.length">
                    <div :class="[(item.rightTwo.transcripts.join(', ').length <= 120 && item.rightTwo.transcripts.length <= 5) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                      <div class="c-voice-text__content" v-html="getTranscripts(item.rightTwo.transcripts)" ></div>
                      <div v-if="item.rightTwo.transcripts.join(', ').length > 120 || item.rightTwo.transcripts.length > 5" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                        <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                        <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="text-center mt-2" v-if="!item.finishTime && !item.rightTwo.confirmTime && !item.rightTwo.cancelTime">
                    <button type="button" class="btn btn-sm btn-primary mr-1" @click="update('rightTwo', item)">
                      <i class="fa fa-edit mr-0"></i>
                      {{$t("edit")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-danger mr-1" @click="reject('rightTwo', item)">
                      <i class="fa fa-remove mr-0"></i>
                      {{$t("reject")}}
                    </button>
                    <button type="button" class="btn btn-sm btn-success" @click="approve('rightTwo', item)">
                      <i class="fa fa-check-circle mr-0"></i>
                      {{$t("approve")}}
                    </button>
                  </div>
                </template>
                <div v-else class="text-center small text-gray-999">{{$t('noAction')}}</div>
              </fieldset>
              <fieldset v-if="item.rightDiffWords" class="scheduler-border alert alert-info mb-0" >
                <legend class="scheduler-border mb-0">
                  <b style="font-size: 14px">{{$t("diffWords")}} {{Math.ceil(item.rightDiffWords.similarity)}}%</b>
                </legend>
                <div>
                  <div :class="[(item.rightDiffWords.text.length <= 120) || item.showMore ? 'c-voice-text active' : 'c-voice-text']">
                    <div class="c-voice-text__content" v-html="item.rightDiffWords.text" ></div>
                    <div v-if="item.rightDiffWords.text.length > 120" class="c-voice-text__btn" @click="item.showMore = !item.showMore">
                      <span class="c-voice-text__expand">{{ $t('seeMore') }}</span>
                      <span class="c-voice-text__close">{{ $t('collapse') }}</span>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-lg-1 text-center">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col" v-if="['owner', 'admin', 'tech'].includes($store.state.user.role)">
                    <button @click="del(item._id)" type="button"
                            class="btn btn-sm btn-danger mr-1">
                      <font-awesome-icon icon="trash" />&nbsp;{{ $t('delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="saveTranscript" no-close-on-backdrop no-enforce-focus>
      <template v-if="formModel.call">
        <p>
          <font-awesome-icon :class="iconClass(formModel.call)" size="2x" :icon="icon(formModel.call)" />
          {{ $t(formModel.call.direction) }} | <span>{{ formModel.call.hangupCause }}</span>
        </p>
        <p>
          <b>ID:&nbsp;</b><span>{{ formModel.call._id.toString() }}</span>
        </p>
        <p>
          <b>{{ $t('duration') }}:&nbsp;</b><span>{{ formModel.call.duration | callDuration }}</span>
        </p>
        <p>
          <b>{{ $t('billDuration') }}:&nbsp;</b><span>{{ formModel.call.billDuration | callDuration }}</span>
        </p>
        <app-audio v-if="formModel.call.recordingDownloaded" :id="formModel.call._id" :duration="formModel.call.duration" class="mb-2" />
      </template>
      <div class="alert alert-warning" :class="[['leftOne', 'leftTwo'].includes(formModel.type) ? 'alert-warning' : 'alert-info']">{{$t(formModel.type)}}</div>

      <form-array :label="$t('content')" :model="formModel" attribute="transcripts" :errors="formErrors" />
    </b-modal>
  </main>
</template>
<script>
import List from '@/mixins/List';
import CRUD from "@/mixins/CRUD";
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import AppAudio from "@/components/AppAudio.vue";
import FormArray from "./FormArray";
import AdminUserSelect from '@/components/AdminUserSelect.vue'

export default {
  components: { AdminUserSelect, AppAudio, TimeRangePicker, FormArray},
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/admin-call',
      tab: 0,
      defaultFilterFormModel: {
        user: null,
        approveBy: null,
        time: 'createTime',
        status: 0
      },
      autoLoad: true
    }
  },
  i18n: {
    messages: {
      en: {
        translateCall: "Cuộc gọi",
        callInfo: "Thông tin cuộc gọi",
        left: "Bên nhân viên",
        right: "Bên khách",
        one: "Biên dịch lần 1",
        two: "Biên dịch lần 2",
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
        doing: "Đang dịch",
        seeMore: "Xem thêm",
        collapse: "Thu gọn",
        noAction: "Chưa biên dịch",
        approve: "Duyệt",
        reject: "Từ chối",
        confirm: "Xác nhận",
        rejectAlert: "Bạn chắc chắn từ chối bản dịch này. Vui lòng nhập lý do cụ thể",
        approveAlert: "Bạn chắc chắn duyệt bản dịch này",
        reason: 'Lý do',
        finish: "Hoàn thành",
        leftOne: "Chỉ dịch tiếng của nhân viên",
        leftTwo: "Chỉ dịch tiếng của nhân viên",
        rightOne: "Chỉ dịch tiếng của khách",
        rightTwo: "Chỉ dịch tiếng của khách",
        content: "Nội dung biên dịch",
        adminChange: "Admin chỉnh nội dung",
        translator: "Người biên dịch",
        approveBy: "Người kiểm duyệt",
        finishTime: "Hoàn thành lúc",
        filterByCreateTime: "Lọc theo thời gian tạo",
        filterBySubmitTime: "Lọc theo thời gian dịch",
        filterByConfirmTime: "Lọc theo thời gian duyệt",
        filterByCancelTime: "Lọc theo thời gian từ chối",
        filterByFinishTime: "Lọc theo thời gian hoàn thành",
        diffWords: "So sánh"
      },
      vi: {
        translateCall: "Cuộc gọi",
        callInfo: "Thông tin cuộc gọi",
        left: "Bên nhân viên",
        right: "Bên khách",
        one: "Biên dịch lần 1",
        two: "Biên dịch lần 2",
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        submit: "Chờ duyệt",
        canceled: "Từ chối",
        confirmed: "Đã duyệt",
        submitTime: "Dịch lúc",
        confirmTime: "Duyệt lúc",
        cancelTime: "Từ chối lúc",
        confirmBy: "Nhân viên duyệt",
        cancelBy: "Nhân viên từ chối",
        doing: "Đang dịch",
        seeMore: "Xem thêm",
        collapse: "Thu gọn",
        noAction: "Chưa biên dịch",
        approve: "Duyệt",
        reject: "Từ chối",
        confirm: "Xác nhận",
        rejectAlert: "Bạn chắc chắn từ chối bản dịch này. Vui lòng nhập lý do cụ thể",
        approveAlert: "Bạn chắc chắn duyệt bản dịch này",
        reason: 'Lý do',
        finish: "Hoàn thành",
        leftOne: "Chỉ dịch tiếng của nhân viên",
        leftTwo: "Chỉ dịch tiếng của nhân viên",
        rightOne: "Chỉ dịch tiếng của khách",
        rightTwo: "Chỉ dịch tiếng của khách",
        content: "Nội dung biên dịch",
        adminChange: "Admin chỉnh nội dung",
        translator: "Người biên dịch",
        approveBy: "Người kiểm duyệt",
        finishTime: "Hoàn thành lúc",
        filterByCreateTime: "Lọc theo thời gian tạo",
        filterBySubmitTime: "Lọc theo thời gian dịch",
        filterByConfirmTime: "Lọc theo thời gian duyệt",
        filterByCancelTime: "Lọc theo thời gian từ chối",
        filterByFinishTime: "Lọc theo thời gian hoàn thành",
        diffWords: "So sánh"
      }
    }
  },
  methods: {
    saveTranscript: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      this.$service({url: `${this.service}/change/${this.formModel.id}`, method: "put", data: this.formModel}).then(response => {
        this.showForm = false;
        this.formModel = {};
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t(this.formModel.id ? 'updated' : 'created'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t(this.formModel.id ? 'updateFailed' : 'createFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    update: function (type, item) {
      this.formModel = {};
      this.formTitle = this.$t('update');
      this.formErrors = [];
      this.showForm = true;
      this.formModel = {
        id: item._id,
        call: item.call,
        type: type,
        transcripts: item[type].transcripts
      };
    },
    reject(type, item) {
      this.$swal({
        title: this.$t('confirm'),
        text: this.$t('rejectAlert'),
        icon: "warning",
        input: 'text',
        inputPlaceholder: this.$t('reason'),
        confirmButtonText: this.$t('reject'),
        confirmButtonColor: "#dc3545",
        inputValue: '',
        inputAttributes: {
          required: 'true'
        },
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/reject/' + item._id, {
            type: type,
            note: result.value
          }).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('confirmSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('confirmFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    approve(type, item) {
      this.$swal({
        title: this.$t('confirm'),
        text: this.$t('approveAlert'),
        icon: "warning",
        input: 'text',
        inputPlaceholder: this.$t('reason'),
        confirmButtonText: this.$t('approve'),
        confirmButtonColor: "#28a745",
        inputValue: '',
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let loader = this.$loading.show();
          this.$service.put(this.service + '/approve/' + item._id, {
            type: type,
            note: result.value
          }).then(response => {
            if (response.data) {
              this.load();
              this.$swal({
                title: this.$t('confirmSuccess'),
                icon: 'success',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                title: this.$t('error'),
                text: this.$t('confirmFailed'),
                icon: 'error'
              });
            }
          }).catch(error => {
            if (error.response.data.message) {
              this.$swal({
                text: error.response.data.message,
                icon: 'error'
              });
            }
          }).finally(() => {
            loader.hide();
          });
        }
      });
    },
    apply: function (data) {
      for(let item of data.docs){
        item.showMore = false
      }
      this.items = data.docs;
      this.itemCount = data.totalDocs;
    },
    icon(item) {
      if (item.direction === 'inbound') {
        return 'sign-in-alt';
      }
      if (item.direction === 'outbound') {
        return 'sign-out-alt';
      }
      if (item.direction === 'local') {
        return 'sync-alt';
      }
    },
    iconClass(item) {
      if (item.hangupCause === 'NORMAL_CLEARING') {
        return 'text-success';
      } else {
        return 'text-danger';
      }
    },
    getTranscripts(transcripts) {
      if(!transcripts || !transcripts) {
        return  ''
      }
      return `<ul class="mb-0"><li>${transcripts.join('</li><li>')}</li></ul>`
    },
  },
  mounted() {

  },
}
</script>

<style lang="scss">
$white: #FFF;
$primary-color: #1284e7 !default;
@mixin transition-all($s){
  -webkit-transition:all $s ease;
  -moz-transition:all $s ease;
  transition:all $s ease;
}
@mixin linear-gradient($poi, $color1, $color2){
  background: linear-gradient($poi, $color1, $color2);
  background: -webkit-linear-gradient($poi, $color1, $color2); /* Firefox 3.6+ */
  background: -moz-linear-gradient($poi, $color1, $color2); /* IE 10 */
  background: -ms-linear-gradient($poi, $color1, $color2); /* Opera 11.10+ */
  background: -o-linear-gradient($poi, $color1, $color2);
}
.c-voice-text{
  &__content{
    font-size: 14px;
    line-height: 18px;
    overflow: hidden;
    max-height: 18px * 3;
    position: relative;
    z-index: 1;
    @include transition-all(0.2s);
    &:after{
      content: "";
      position: absolute;
      z-index: 2;
      bottom: 0;
      right: 0;
      left: 0;
      height: 18px;
      @include linear-gradient(to right, transparent, $white);
    }
    p{
      margin: 0;
    }
    .text-gray-999{
      position: relative;
      z-index: 4;
    }
  }
  &__btn{
    padding-top: 5px;
    text-align: left;
  }
  &__close{
    display: none;
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
  }
  &__expand{
    cursor: pointer;
    margin-right: 7px;
    font-size: 12px;
    color: $primary-color;
  }
  &.active{
    .c-voice-text__content{
      max-height: none;
      &:after{
        display: none;
      }
    }
    .c-voice-text__expand{
      display: none;
    }
    .c-voice-text__close{
      display: inline;
    }
  }
}
</style>